module.exports = __webpack_public_path__ + "media/gallery/4-e45cd07d.jpg";